// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CompanyDepartments_wrapper__pUPuU","departmentsWrapper":"CompanyDepartments_departmentsWrapper__1LFQi","showMoreBtn":"CompanyDepartments_showMoreBtn__3KEeN"};